import { combineReducers } from "redux";
import invoiceItemsReducer from "./invoiceItemsReducer";
import itemsReducer from "./itemsReducer";
import permissionsReducer from "./permissionsReducer";

export default combineReducers({
  invoiceItems: invoiceItemsReducer,
  items: itemsReducer,
  permissions: permissionsReducer,
});
